import { table } from './_table';

export const sip_accounts = {
  namespaced: true,
  modules: {
    table
  }
};
